/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.1.3): alert.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */

import $ from 'jquery';
import EventHandler from '../../bootstrap/dom/event-handler.js';
import MpBaseComponent from './base-component.js';

/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

export const NAME = 'alert';
export const DATA_KEY = 'bs.alert';
export const EVENT_KEY = `.${DATA_KEY}`;

export const EVENT_CLOSE = `close${EVENT_KEY}`;
export const EVENT_CLOSED = `closed${EVENT_KEY}`;
export const CLASS_NAME_FADE = 'fade';
export const CLASS_NAME_SHOW = 'show';

/**
 * @typedef {{
 * disposeOnHide?: boolean;
 * dismissActions?: MpDataAction[];
 * }} MpAlertOptions
 */

/**
 * @type {MpAlertOptions}
 */
export const Default = {
	disposeOnHide: true,
};

export const DefaultType = {
	disposeOnHide: 'boolean',
};

/**
 * ------------------------------------------------------------------------
 * Class Definition
 * ------------------------------------------------------------------------
 */

export default class MpAlert extends MpBaseComponent {

	// ==============
	// Props
	// ==============

	// * =====
	// * NOTE: Don't put any props here because this is an extended class and the super constructor will be called before anything else and it will break everything
	// * =====

	// =======================================================================================

	// ==============
	// Static Getters
	// ==============

	static get NAME() {
		return NAME;
	}

	static get DefaultType() {
		return DefaultType;
	}

	static get Default() {
		return Default;
	}

	// Public

	close() {
		const closeEvent = EventHandler.trigger(this._element, EVENT_CLOSE);

		if (closeEvent.defaultPrevented) {
			return;
		}

		// Execute the dismiss action
		if (this._config.dismissActions) {
			this._handleDismissActions(this._config.dismissActions);
		}

		const isAnimated = this._element.classList.contains(CLASS_NAME_FADE);
		this.startAnim(this._element, [CLASS_NAME_SHOW], 'remove', isAnimated).done(() => {
			this._destroyElement();
		});
	}

	// Private
	_destroyElement() {
		this._element.remove();
		EventHandler.trigger(this._element, EVENT_CLOSED);
		this.dispose();
	}
}

// Add init function that is executed only on first dom-ready (it should contain only document/body delegate handlers)
mpro.addInitDelegate(() => {

	// Delegate handler to enable closing instances
	MpAlert.enableDismissTrigger('close', false);
});


MpAlert.defineJQueryPlugin();